import * as React from "react";
import image from "../assets/logo.png";
import { StyleSheet } from 'react-native';
import { fontSize } from "@mui/system";
import { useTranslation } from 'react-i18next';
import i18n from '../assets/lang/i18next';


const styles = StyleSheet.create({
  flash: {
    width: '100%', backgroundColor: '#000'
  },
  testClass: {
    backgroundColor: 'red'
  }
})
export class ComponentToPrint extends React.PureComponent {

  constructor(props) {

    super(props);

    this.state = { checked: false };
  }

  canvasEl;

  componentDidMount() {
    const ctx = this.canvasEl.getContext("2d");
    if (ctx) {
      ctx.beginPath();
      ctx.arc(95, 50, 40, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.fillStyle = "rgb(200, 0, 0)";
      ctx.fillRect(85, 40, 20, 20);
      ctx.save();
    }
  }

  handleCheckboxOnChange = () =>
    this.setState({ checked: !this.state.checked });

  setRef = (ref) => (this.canvasEl = ref);

  render() {
    const { text } = this.props;
    return (


      <div style={{ backgroundColor: 'white', width: '100%', fontFamily: 'IranSans', padding: 50 }}>
        <style type="text/css" media="print">
          {"\   @page  {  size: A4 portrait; }\
"}
        </style>
        <div />
        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
          <thead style={{ backgroundColor: 'white', width: '100%', border: 'none' }}>
            <tr >
              <th style={{ border: 'none' }}><h3>{i18n.t('calculatecoolingload')}</h3></th>
              <th style={{ border: 'none' }}></th>
              <th style={{ border: 'none' }}><img alt="arshehar" src={image} width="85" /></th>
            </tr>
          </thead>
        </table>
        <hr></hr>
        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
          <tbody style={{ border: 'none' }} >
            <tr style={{ display: 'none' }}>
              <td>Canvass</td>
              <td>
                <canvas height="100" ref={this.setRef} width="200">
                </canvas>
              </td>
            </tr>
            <tr style={{ borderBottom: '1pt solid black}' }}>
              <td> <h4 style={{ fontSize: 14, margin: 0, padding: 0, marginTop: 20 }}>{i18n.t('generaldata')}</h4></td>
            </tr>
            <tr >
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('roomtemperature')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.damayotagh}</p> </td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>C°</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('outsidetemperature')}</p></td>
              <td>
                <p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.ekhtelaf}</p>
              </td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>C°</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('ventilationlossfactor')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.shadat}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('runningtimeinstallation')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zamansystem}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('lengthwidthheight')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.tae}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>m</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('RoomVolume')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.hajm}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>m³</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('isolationmaterial')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.ayegh}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('isolationthicknessofwallsandfloor')}</p> </td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zekhamatdivar}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>mm</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('floorisolationthickness')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zekhamatkaf}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>mm</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('k-valueisolationpanel')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zaribhadayatayegh}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>W/m2K</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('fanspower')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.tavanfan}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>Watt / hrs/day</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('illumination')}</p> </td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.roshanaei}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>Watt/m^2 / hrs/day</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('persons')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.tedadkatgar}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>hrs/day</p> </td>
            </tr>


            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('forkliftsothers')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.liftrag}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>Watt / hrs/day</p></td>
            </tr>

            <tr>
              <td style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('producttype')}</td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.mahsol}</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('storagequantity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatbargiri}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kg</p> </td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('stockshift')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatbargirirozaneh}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kg</p> </td>
            </tr>


            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('enteringtemperature')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.damayvorodi}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>C°</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('cooldowncongelationtime')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zamansardsazi}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>hr</p></td>
            </tr>

          </tbody>
        </table>
        <hr></hr>
        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
          <tbody>

            <tr>
              <td><h4 style={{ fontSize: 14, margin: 0, padding: 0, marginTop: 20 }}>{i18n.t('loaddetails')}</h4></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('TransmissionLosses')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.talafatjedareha}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>


            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('VentilationLosses')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.talafathava}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('OtherHeatLosses')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.mabaghihararati}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>


            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('CoolingDownLoad')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.barsardsazi}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('RespirationLoad')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.bartanafosi}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>


            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0, fontWeight: 900 }}>{i18n.t('total')}</p> </td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.majmo.toFixed(3)}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>kw</p></td>
            </tr>
          </tbody>
        </table>

        <p style={{ fontSize: 14, direction: 'ltr', color: 'red', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900, marginBottom: 15, marginTop: 15 }}>{i18n.t('Part1Ans')} {this.props.person.zamansystem} {i18n.t('Part2Ans')} {this.props.person.qn} {i18n.t('KW')}</p>

        <hr></hr>

        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', }}>
          <tbody style={{ border: 'none' }} >
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('Evaporatingtemperature')}  (Te)</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.te}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>℃</p></td>
            </tr>

            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('CondensingSDT')} (Tc)</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.tc}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>℃</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('refrigerant')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.mobared}</p></td>

            </tr>

          </tbody>
        </table>
        <hr></hr>

        <div style={{ whiteSpace: "pre-line" }}></div>
        <br></br>
        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', }}>
          <tbody style={{ border: 'none' }} >
            <tr>
              <td><h4 style={{ fontSize: 14, margin: 0, padding: 0, marginTop: 40 }}>{i18n.t('selectdevice')}</h4></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('Compressor')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.selectcompresor}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('compressorbrand')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.brand == 1 ? "Bitzer" : "Bock"}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('EvaporatorCapacity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatevaprator}</p></td>
            </tr>
          </tbody>
        </table>

        <hr></hr>

        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', }}>
          <tbody style={{ border: 'none' }} >
            <tr>
              <td><h4 style={{ fontSize: 14, margin: 0, padding: 0, marginTop: 20 }}>{i18n.t('Evaporator')}</h4></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('Evaporator')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.txtlabelevaprator}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('Thenumberofevaporators')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.txttedadevaprator}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('evaporatorrbrand')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.selectcompanyevaprator}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('evaporatorActualCapacity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatkarbordievaprator}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('Nominalcapacity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatnami}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('SafetyFactor')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zaribetminanevaprator}</p></td>
            </tr>
          </tbody>
        </table>

        <hr></hr>

        <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', }}>
          <tbody style={{ border: 'none' }} >
            <tr>
              <td><h4 style={{ fontSize: 14, margin: 0, padding: 0, marginTop: 20 }}>{i18n.t('Condenser')}</h4></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}>{i18n.t('Condenser')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.sellabelcondonsor}</p></td>

              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('Condenserbrand')}  </p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.selectcompanycond}</p></td>
            </tr>
            <tr>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('CondenserActualCapacity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatkarbordicondonsor}</p></td>
              <td><p style={{ fontSize: 12, margin: 1, padding: 0 }}> {i18n.t('CondenserNominalcapacity')}</p></td>
              <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'center', margin: 0, padding: 0, fontWeight: 900 }}>{this.props.person.zarfiyatnamicond}</p></td>

            </tr>
          </tbody>
        </table>

        <div style={{ backgroundColor: 'red', width: '100%', height: 35, direction: 'ltr', display: 'flex', flexDirection: 'row', justifyContent: 'space-between',marginTop:10 }}>
          <h3 style={{ color: 'white', marginLeft: 10, fontSize: 13 }}>app.arshehkar.com</h3>
          <h3 style={{ color: 'white', marginRight: 20, fontSize: 13 }}>info@arshehkar.com</h3>

        </div>
      </div>
    );
  }
}

export const FunctionalComponentToPrint = React.forwardRef((props, ref) => {
  // eslint-disable-line max-len
  return <ComponentToPrint ref={ref} text={props.text} />;
});
